import { useRef, useEffect } from "react";
import { telemetry } from "utilities/telemetry";
import type { OtpFlowName } from "../utils/types";
import { getChannelFromModal } from "../utils/getChannelFromModal";
import { otpFlowTracking } from "../utils/constants";
import { getOtpFlowStore } from "../stores/otpStore";

const useOtpTelemetry = (flow: OtpFlowName) => {
  const useOtpStore = getOtpFlowStore(flow);

  const { origin, channel } = otpFlowTracking[flow];

  const trackedAttemptsRef = useRef<Set<string>>(new Set());

  useEffect(() => {
    const unsub = useOtpStore.subscribe((state, prevState) => {
      const wasSubmitting = prevState.isSubmitting;

      const status = state.status;

      const isSuccess = wasSubmitting && status === "codeSent";
      const isFailure = wasSubmitting && status === "invalid";

      if (!isSuccess && !isFailure) return;

      const key = state.session?.verificationRequestId ?? Date.now().toString();
      if (trackedAttemptsRef.current.has(key) && isSuccess) return;

      trackedAttemptsRef.current.add(key);

      telemetry.otpVerificationRequested({
        channel: getChannelFromModal(channel),
        origin,
        outcome: isFailure ? "failure" : "success",
      });
    });

    return unsub;
  }, [origin, channel]);
};

export { useOtpTelemetry };
